import { connect } from 'react-redux';
import { compose } from 'redux';

import withReducer from '@Hooks/withReducer';
import { stateParams as stateParamsSelector } from '@Selectors/StateParamsSelectors';
import { relativeContextItemsByHitSetKey as relativeContextItemsByHitSetKeySelector } from '@Containers/RelativeContext/RelativeContextSelectors';
import listOfFiltersReducer from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersReducer';
import { listOfFiltersReducerKey } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersConstants';
import { open as openHeatmapIndicator, fullScreenMode as heatmapFullScreenModeIndicator } from '@Pages/Heatmap/selectors';
import { setDrawingFromResults } from '@Containers/ResultsFilters/ResultsFiltersComponents/StructureFilter/StructureFilterActions';
import openCloseResultsFiltersHOC from './OpenCloseResultsFiltersHOC';
import ResultsFilters from './ResultsFilters';
import resultsFiltersReducer from './ResultsFiltersReducer';
import { resultsFiltersReducerKey } from './ResultsFiltersConstants';
import { open } from './ResultsFiltersSelectors';
import { setOpenFilters } from './ResultsFiltersActions';

function mapStateToProps(state) {
  const stateParams = stateParamsSelector(state);
  const hitSetKey = stateParams && stateParams.get('hitSetKey');
  const relativeContextRetrieved = !!relativeContextItemsByHitSetKeySelector(state, { hitSetKey });
  return {
    open: open(state),
    openHeatmapIndicator: openHeatmapIndicator(state),
    relativeContextRetrieved,
    heatmapFullScreenModeIndicator: heatmapFullScreenModeIndicator(state),
  };
}

const mapDispatchToProps = {
  setOpenFilters,
  setDrawingFromResults,
};

export default compose(
  withReducer(resultsFiltersReducerKey, resultsFiltersReducer, true),
  withReducer(listOfFiltersReducerKey, listOfFiltersReducer),
  connect(mapStateToProps, mapDispatchToProps),
  openCloseResultsFiltersHOC
)(ResultsFilters);
